// http://pkk5.rosreestr.ru/arcgis/rest/services/Cadastre/CadastreSelected/MapServer/export?dpi=96&transparent=true&format=png32&layers=show%3A10&bbox=5539327.669175136%2C8384958.095826377%2C7726038.174356877%2C10006646.087924246&bboxSR=102100&imageSR=102100&size=894%2C663&layerDefs=10%3AID%20%3D%20%2786%27&f=image
var ol = require('openlayers');
var this_parent = ol.source.PKK5ArcGISSource;
ol.source.PKK5ArcGISHighlightSource = function(opt_options) {
    /**
     * Строка с id фичи, которую нужно подсветить
     * @type {string}
     */
    this.selected_feature = null;

    this_parent.call(this, opt_options)
};
ol.inherits(ol.source.PKK5ArcGISHighlightSource, this_parent);


ol.source.PKK5ArcGISHighlightSource.prototype.setSelectedFeature = function(feature_id) {
    if (feature_id === null) {
        this.selected_feature = null;
    } else {
        this.selected_feature = feature_id + '';
    }

    this._reloadTiles();
};

ol.source.PKK5ArcGISHighlightSource.prototype._reloadTiles = function() {
    this.emptyCache();
    this.refresh();
};

ol.source.PKK5ArcGISHighlightSource.prototype.emptyCache = function() {
    this.tileCache.expireCache({});
    this.tileCache.clear();
}

/* 
    Эта функция такая же как и у парента, кроме того что к запросу добавляется 
    параметр layerDefs, который содержит id фичи, которую надо выделить
*/
ol.source.PKK5ArcGISHighlightSource.prototype.getRequestUrl_ = function(
    tileCoord, 
    tileSize, 
    tileExtent,
    pixelRatio, 
    projection, 
    params
) {

    var urls = this.urls;
    var tileGrid = this.getTileGrid();
    var selected_feature = this.selected_feature;

    if (!urls) {
        return undefined;
    }

    var layer_ids = [0, 1 , 2, 3, 4, 5, 6, 7, 8, 9, 10];
    // var layers = 'show:0,1,2,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,23,24,29,30,31,32,33,34,35,38,39';

    var srid = projection.getCode().split(':').pop();

    var layerDefs = {};
    if (selected_feature) {
        for (var i = 0; i < layer_ids.length; i++) {
            var layer_id = layer_ids[i];
            layerDefs[layer_id] = "ID = '" + selected_feature + "'";
        }
    }

    // поменял параметры в lowerCase
    params['layers'] = 'show:' + layer_ids.join(',');
    params['dpi'] = 96;
    params['format'] = 'PNG32';
    // params['bbox'] = tileExtent.join(',');
    params['bbox'] = this.calculatePKK5Extent(tileCoord, tileSize).join(',');
    params['bboxSR'] = /*srid*/ '102100';
    params['imageSR'] = /*srid*/ '102100';
    params['size'] = tileSize[0] + ',' + tileSize[1];
    params['transparent'] = true;
    params['f'] = 'image';
    if (selected_feature) {
        params['layerDefs'] = JSON.stringify(layerDefs);
    }
    // params['dpi'] = Math.round(
    //         params['dpi'] ? params['dpi'] * pixelRatio : 90 * pixelRatio
    // );

    var url;
    if (urls.length == 1) {
        url = urls[0];
    } else {
        var index = ol.math.modulo(ol.tilecoord.hash(tileCoord), urls.length);
        url = urls[index];
    }

    var modifiedUrl = url
            .replace(/MapServer\/?$/, 'MapServer/export')
            .replace(/ImageServer\/?$/, 'ImageServer/exportImage');
    return ol.uri.appendParams(modifiedUrl, params);
};






//////////////////
// WEBPACK FOOTER
// ./src/View/PKK5ArcGISHighlightSource.js
// module id = 34
// module chunks = 0